import { render, staticRenderFns } from "./WelcomeSocialBrandIcon.vue?vue&type=template&id=e4f22580"
import script from "./WelcomeSocialBrandIcon.vue?vue&type=script&lang=js"
export * from "./WelcomeSocialBrandIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports